import React, { FC } from 'react';
import classNames from 'classnames';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';
import {
  DraftedByCellComponent,
  DraftedCellComponent,
  SubjectCellComponent,
} from '../../QAndABuyerContainer.component';
import useManageQuestion from '../../hooks/useManageQuestion';
import { PRIORITY_ICONS } from 'router/subrouters/DataRoom/providers/QAndA/QAndA.provider';

import './QAndAMobileCard.styles.scss';

type QAndAMobileCardProps = {
  className?: string;
  question: Question;
  isManagingRole?: boolean;
};

const QAndAMobileCard: FC<QAndAMobileCardProps> = ({
  className,
  question,
  isManagingRole,
}) => {
  const { YourDrawer, cantManageQuestion, onManageClick } =
    useManageQuestion(question);

  const hasCreatedDate = !!question.createdAt;
  const hasDrawer = isManagingRole && !cantManageQuestion;

  const classes = classNames(
    'q-and-a-mobile-card',
    { clickable: hasDrawer },
    className,
  );

  return (
    <>
      <div
        className={classes}
        onClick={() => {
          if (!hasDrawer) return;
          onManageClick();
        }}
      >
        <SubjectCellComponent question={question} />

        <div className="q-and-a-mobile-card__row">
          {PRIORITY_ICONS[question.priority]}
          <DraftedByCellComponent question={question} />

          {hasCreatedDate && (
            <>
              <div className="q-and-a-mobile-card__dot" />
              <DraftedCellComponent question={question} />
            </>
          )}
        </div>
      </div>
      {hasDrawer && YourDrawer}
    </>
  );
};

export default QAndAMobileCard;
